export const MODIFY_MODAL_IMAGE_URL = 'MODIFY_MODAL_IMAGE_URL';

export function modifyModalImageURL(modalImageURL){
    return{
        type: MODIFY_MODAL_IMAGE_URL,
        mainState: {
            modalImageURL: modalImageURL
        }
    }
}